export default __webpack_public_path__ + "static/mobile-cf97d218d1d9dc120c829f4259a34cd9.jpg";